module.exports = __webpack_public_path__ + "static/img/10.59298cf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/zh/10.png
// module id = Z5z2
// module chunks = 0